import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { ApartmentOutlined, ArrowRightOutlined, CheckOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { Avatar, Button, Form } from 'antd';
import { GetCompanyGroup } from '../../appRedux/actions/Selector/CompanyGroup';
import { setEncriptionCompanyGroup } from '../../appRedux/actions/Auth';
import SelectDA from '../../components/Select';
import LoginHeader from '../Topbar/LoginHeader/index';
import BackGround from '../../assets/images/b.png';
import UserImage from '../../assets/images/icono.png';

const FormItem = Form.Item;

const CompanyGroup = ({ location }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isMounting = React.useRef(true);
  const { loader, authUser, user } = useSelector(({ auth }) => auth);
  const { CompanyGroups } = useSelector(({ CompanyGroup }) => CompanyGroup);
  const [form] = Form.useForm();

  useEffect(() => {
    if (!authUser) {
      history.push('/');
      return;
    }

    if (isMounting.current) {
      isMounting.current = false;
      dispatch(GetCompanyGroup());
    } else if (CompanyGroups.length === 1) {
      onSubmitForm({ CompanyGroup: CompanyGroups[0].id });
    }
  }, [loader, CompanyGroups, authUser]);

  const onSubmitForm = values => {
    dispatch(setEncriptionCompanyGroup(CompanyGroups.find(group => group.id === values.CompanyGroup)));
    history.push({
      pathname: '/companySelector',
      state: { CompanyGroup: values.CompanyGroup }
    });
  };

  const backgroundStyle = {
    backgroundImage: `url(${BackGround})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <div className="dasi-company-group">
      <LoginHeader compact />
      {user != null ? (
        <main className="dasi-company-group__main" style={backgroundStyle}>
          <section className="dasi-company-group__card">
            <aside className="dasi-company-group__profile">
              <div className="dasi-company-group__profile-glow" aria-hidden="true" />
              <span className="dasi-company-group__session">
                <SafetyCertificateOutlined /> Sesión segura
              </span>

              <div className="dasi-company-group__user">
                <Avatar shape="circle" size={72} src={UserImage} />
                <div>
                  <span>Bienvenido/a</span>
                  <h1>{`${user?.firstName} ${user?.lastName}`}</h1>
                  <p>{user.email}</p>
                </div>
              </div>

              <div className="dasi-company-group__steps" aria-label="Proceso de configuración">
                <div className="dasi-company-group__step dasi-company-group__step--active">
                  <span>1</span>
                  <div><strong>Grupo</strong><small>Selecciona tu grupo empresarial</small></div>
                  <CheckOutlined />
                </div>
                <div className="dasi-company-group__step">
                  <span>2</span>
                  <div><strong>Compañía</strong><small>Elige la empresa de trabajo</small></div>
                </div>
                <div className="dasi-company-group__step">
                  <span>3</span>
                  <div><strong>Sucursal</strong><small>Define tu ubicación activa</small></div>
                </div>
              </div>
            </aside>

            <div className="dasi-company-group__content">
              <div className="dasi-company-group__content-inner">
                <span className="dasi-company-group__eyebrow">
                  <ApartmentOutlined /> Grupo empresarial
                </span>
                <h2>¿Con qué grupo deseas trabajar?</h2>

                <Form
                  form={form}
                  onFinish={onSubmitForm}
                  layout="vertical"
                  className="dasi-company-group__form">
                  <FormItem
                    name="CompanyGroup"
                    className="dasi-company-group__select-item"
                    rules={[{ required: true, message: 'Selecciona un grupo para continuar.' }]}>
                    <SelectDA
                      onChange={() => form.submit()}
                      toShow={["", "", "display"]}
                      data={CompanyGroups}
                      placeHolder="Selecciona un grupo"
                      Style={{ width: '100%' }}
                      Size="large"
                      DropdownClassName="dasi-company-group-dropdown" />
                  </FormItem>

                  <p className="dasi-company-group__availability">
                    {CompanyGroups.length} {CompanyGroups.length === 1 ? 'grupo disponible' : 'grupos disponibles'}
                  </p>

                  <FormItem className="dasi-company-group__submit-item">
                    <Button size="large" htmlType="submit" block className="dasi-company-group__submit">
                      <span>Continuar</span>
                      <ArrowRightOutlined />
                    </Button>
                  </FormItem>
                </Form>
              </div>

            </div>
          </section>
        </main>
      ) : (
        <Redirect to={{ pathname: '/signin', state: { from: location } }} />
      )}
    </div>
  );
};

export default CompanyGroup;
